/**
 * Theme registry: the bespoke theme for a dungeon, or the generic fallback.
 */
import type { DungeonDef } from '@keystone/sim';
import { GENERIC_THEME } from './generic';
import type { DungeonTheme } from './types';
import { venomAltarTheme } from './venomAltar/theme';
import { hollowBarrowTheme } from './hollowBarrow/theme'; // +field
import { outdoorDungeonTheme, outdoorThemeFor } from '../outdoor/themes'; // +field

const THEMES: Record<string, DungeonTheme> = {
  venom_altar: venomAltarTheme,
  hollow_barrow: hollowBarrowTheme, // +field: the starter dungeon under Sunmeadow
};

export function themeFor(d: DungeonDef | undefined): DungeonTheme {
  // +field: open fields / the town use the outdoor themes (by DungeonDef.field.theme).
  const out = outdoorThemeFor(d);
  if (out) return outdoorDungeonTheme(out);
  return (d && THEMES[d.id]) || GENERIC_THEME;
}

export { GENERIC_THEME, venomAltarTheme };
export type { DungeonTheme } from './types';
